import { Injectable, OnInit, OnDestroy } from '@angular/core';
import { XhrService } from './xhr.service';
import { AuthGuard } from './auth-guard.service';
import { TranslateService } from '@ngx-translate/core';
import { FAuth } from '../auth/shared/fAuth';
import { apiUrl, downloadPath } from '../shared/config';

@Injectable()
export class ToastService implements OnInit, OnDestroy {
  
  msgs:Array<any>=[];
  
  constructor(private xhrService: XhrService, public authGuard: AuthGuard, private translate: TranslateService) {
    
  }
  showSuccess(msg:string,title?:string){
    this.msgs.push({severity:'success', summary:title, detail:msg});
  }
  showInfo(msg:string,title?:string){
    this.msgs.push({severity:'info', summary:title, detail:msg});
  }
  showWarn(msg:string,title?:string){
    this.msgs.push({severity:'warn', summary:title, detail:msg});
  }
  showError(msg:string,title?:string){
    this.msgs.push({severity:'error', summary:title, detail:msg});
  }
  showErrorCode(code:string,title?:string){
    var msg=this.translate.instant('error.code.'+code);
    this.msgs.push({severity:'error', summary:title, detail:msg});
  }

  ngOnInit() {

  }

  ngOnDestroy() {


  }
}


// WEBPACK FOOTER //
// ./src/app/service/toast.service.ts